var _g, _g2, _path, _path2, _g3, _path3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurkmenistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#496e2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m255.999 0c-19.114 0-37.733 2.113-55.651 6.085l-11.13 249.914 11.13 249.915c17.919 3.972 36.538 6.086 55.651 6.086 141.385 0 256-114.616 256-256.001-.001-141.384-114.615-255.999-256-255.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.783 83.571c-41.484 45.496-66.782 106.006-66.782 172.428s25.299 126.932 66.783 172.43l11.13-172.43z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m374.421 193.099c12.595-35.106-1.555-73.287-31.922-92.303 5.462.711 10.93 1.997 16.326 3.932 40.503 14.532 61.557 59.144 47.025 99.646-14.532 40.505-59.144 61.557-99.647 47.025-5.397-1.936-10.436-4.421-15.103-7.344 35.53 4.627 70.726-15.85 83.321-50.956z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.564 91.173-10.945 14.142-16.829-6.039 10.066 14.778-10.943 14.14 17.165-5.006 10.068 14.776.54-17.872 17.166-5.007-16.829-6.037z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.116 137.252-10.945 14.141-16.83-6.039 10.067 14.778-10.944 14.14 17.165-5.008 10.068 14.779.542-17.873 17.165-5.008-16.83-6.038z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.46 107.955-10.945 14.14-16.829-6.037 10.067 14.777-10.944 14.141 17.164-5.007 10.068 14.777.542-17.872 17.165-5.007-16.829-6.039z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.26 160.737-10.944 14.141-16.83-6.038 10.068 14.778-10.946 14.14 17.167-5.006 10.067 14.776.541-17.872 17.166-5.007-16.831-6.039z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.486 178.758-10.945 14.14-16.829-6.038 10.068 14.778-10.946 14.139 17.167-5.006 10.067 14.778.541-17.874 17.166-5.006-16.831-6.038z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m66.783 83.571v344.857c34.88 38.254 81.21 65.879 133.565 77.485v-499.828c-52.356 11.606-98.684 39.231-133.565 77.486z",
    fill: "#d80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m117.753 134.785-22.361-16.658v-23.557l22.361-16.657h31.625l22.361 16.657v23.557l-22.361 16.658z",
    fill: "#f0f0f0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff9811"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.566 77.913h-15.813l-22.361 16.657v11.517h38.174z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.566 134.785h15.812l22.361-16.658v-12.017h-38.173z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m117.753 434.085-22.361-16.658v-23.556l22.361-16.658h31.625l22.361 16.658v23.556l-22.361 16.658z",
    fill: "#f0f0f0"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff9811"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.566 377.213h-15.813l-22.361 16.658v11.517h38.174z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.566 434.085h15.812l22.361-16.658v-12.016h-38.173z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#496e2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m117.753 284.435-22.361-16.658v-23.556l22.361-16.658h31.625l22.361 16.658v23.556l-22.361 16.658z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.522 321.085h-9.74v-9.739h-17.115l-12.102-12.102-12.101 12.102h-17.115v9.739h-9.739v19.478h9.739v9.739h17.114l12.103 12.103 12.101-12.103h17.115v-9.739h9.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.522 171.434h-9.74v-9.74h-17.115l-12.102-12.102-12.101 12.102h-17.115v9.74h-9.739v19.478h9.739v9.739h17.114l12.103 12.104 12.101-12.104h17.115v-9.739h9.74z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.434 244.868h22.261v22.261h-22.261z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.564,
    cy: 181.169,
    r: 11.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.564,
    cy: 330.828,
    r: 11.13
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkmenistan);
export default __webpack_public_path__ + "static/media/turkmenistan.22af9db5304c07356309560be463e49f.svg";
export { ForwardRef as ReactComponent };